import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const OportunidadSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        borderRadius: 2,
        bgcolor: theme.palette.alternate.main,
        borderLeft: 4,
        borderColor: theme.palette.primary.main,
      }}
    >
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 700 }}
        variant="overline"
        color="primary"
        display="block"
        gutterBottom
      >
        Propuesta de valor agregado
      </Typography>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Dos días de evento, meses de visibilidad para sus aliados
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Transformamos un patrocinio de 2 días en una campaña estratégica de 3
        meses.
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Con TNO Network, Expo Mascotas Caracas no se vive solo en el recinto. La
        experiencia comienza antes de abrir puertas y sigue dejando huella mucho
        después del evento.
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Esta alianza le da a los organizadores una propuesta mucho más poderosa
        para patrocinadores y marcas: no solo un espacio físico en feria, sino
        una presencia emocional y sostenida dentro del ecosistema TNO.
      </Typography>

      <Box sx={{ '& > div': { mb: 2 } }}>
        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Antes del evento
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Activamos entrevistas previas en estudio para calentar motores y
            presentar a organizadores, patrocinadores y voceros del bienestar
            animal con el tono humano que conecta.
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Durante los 2 días
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            La cobertura se expande a través de toda nuestra arquitectura:
          </Typography>
          <Box component="ul" sx={{ pl: 2.5, mt: 0, mb: 0 }}>
            <Typography component="li" variant="body2" color="textSecondary">
              <strong>Señal TNO:</strong> rotativa y presencia constante del evento.
            </Typography>
            <Typography component="li" variant="body2" color="textSecondary">
              <strong>Pedro con las Mascotas:</strong> entrevistas y recorrido en
              campo con Pedro Scutaro como anfitrión.
            </Typography>
            <Typography component="li" variant="body2" color="textSecondary">
              <strong>TNO Digest y clips sociales:</strong> historias que extienden
              el alcance de la Expo y de sus patrocinadores.
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Después del evento
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Los momentos más tiernos, útiles y memorables quedan disponibles
            On-Demand para que la comunidad los consulte y las marcas capitalicen
            la conversación mucho más allá del cierre.
          </Typography>
        </Box>
      </Box>

      <Typography
        variant="subtitle2"
        color="primary"
        fontWeight={600}
        sx={{ mt: 3, mb: 1 }}
      >
        El beneficio para el organizador
      </Typography>
      <Typography variant="body1" color="textSecondary">
        El resultado es una Expo con mayor valor percibido, patrocinadores mejor
        respaldados y una narrativa de marca que combina corazón, orden y
        profesionalismo.
      </Typography>
    </Box>
  );
};

export default OportunidadSection;
